import React from 'react';
import { GetStaticPaths, GetStaticProps } from 'next';
import fetchUtil from '../../utils/fetchUtil';
import ErrorComponent from '../../components/ErrorComponent';
import LandingPageComponent from '../../components/ApplicationWeek/LandingPageComponent';
import { CACHE_REVALIDATE_24H } from '../../utils/constants';

const ApplicationsWeek: React.FC = (props: any) => {
    if (!props.pageData || props.pageData.length === 0) {
        return <ErrorComponent />
    }

    return (
        <LandingPageComponent {...props} />
    )
}

export const getStaticPaths: GetStaticPaths = async () => {
    return { paths: [], fallback: 'blocking' };
}

export const getStaticProps: GetStaticProps = async (context) => {
    try {
        const pageData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/applications-week-pages?newSlug=${context.params?.slug}&categoryType=applications_week`, 'GET', {}, '', false)
        return {
            props: {
                pageData
            },
            revalidate: CACHE_REVALIDATE_24H,
        };
    }
    catch(e) {
        return {
            props: {
                pageData:[]
            },
            revalidate: CACHE_REVALIDATE_24H,
        };
    }

}

export default ApplicationsWeek;
